import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios"

Vue.use(Vuex)

var ReportDataList = new Vuex.Store({
    state: {
        streams: {},
        attribute: "age",
        data: {},
        dateCount: 1,
        hasTodayCount: false
    },
    mutations: {
        initialize (state){
            state.streams = {}
            state.data = {}
        }, 
        getAgeData (state, payload) {
            state.attribute = "age"
            state.data = payload.results
            state.dateCount = payload.num_date
            state.hasTodayCount = payload.has_today_count
        },
        getGenderData (state, payload) {
            state.attribute = "gender"
            state.data = payload.results
            state.dateCount = payload.num_date
            state.hasTodayCount = payload.has_today_count
        },
        getStreams (state, payload) {
            state.streams = payload.results
        }
    },
    getters: {
        attribute: state => {
            return state.attribute;
        },
        data: state => {
            return state.data;
        },
        dateCount: state => {
            return state.dateCount;
        },
        hasTodayCount: state => {
            return state.hasTodayCount;
        }
    },
    actions: {
        async initialize(context){
            context.commit('initialize')
        },
        // 年齢
        async getHourlyAgeData (context, {dateFrom, dateTo, condition, streamList}) {

            if(dateFrom==null || dateFrom==""){
                throw new Error("表示期間を入力してください")
            }

            if(dateTo==null || dateTo==""){
                throw new Error("表示期間を入力してください")
            }

            if(dateTo < dateFrom){
                throw new Error("表示期間の終了日は開始日と同じか後の日付を入力してください")
            }

            if(streamList==null || streamList.length < 1){
                throw new Error("カメラを選択してください。")
            }

            const headers = {
                "Content-type" : "application/json",
                'Authorization': sessionStorage.getItem('token')
            }

            const query = {
                start_date: dateFrom,
                end_date: dateTo,
                condition: condition,
                streams: streamList.join(",")
            }
                        
            return await axios
                .get(process.env.VUE_APP_API_ROOT + '/hourly-age-data', {
                    headers: headers,
                    params: query
                })
                .then(({ data }) => {
                    context.commit('getAgeData', data['body'])
                })
                .catch(error => {
                    console.error(error.response.data.errorMessage)
                    if(error.response.status == 401){
                        throw new Error("APIの認証に失敗しました。")
                    } else if (error.response.status === 500) {
                        throw new Error("サーバの問題で取得に失敗しました")
                    } else {
                        throw new Error("データの取得に失敗しました")
                    }
                });
        },
        // 性別
        async getHourlyGenderData (context, {dateFrom, dateTo, condition, streamList}) {

            if(dateFrom==null || dateFrom==""){
                throw new Error("表示期間を入力してください")
            }

            if(dateTo==null || dateTo==""){
                throw new Error("表示期間を入力してください")
            }

            if(dateTo < dateFrom){
                throw new Error("表示期間の終了日は開始日より後の日付を入力してください")
            }

            if(streamList==null || streamList.length < 1){
                throw new Error("カメラを選択してください。")
            }
            
            const headers = {
                "Content-type" : "application/json",
                'Authorization': sessionStorage.getItem('token')
            }

            const query = {
                start_date: dateFrom,
                end_date: dateTo,
                condition: condition,
                streams: streamList.join(",")
            };

            return await axios
                .get(process.env.VUE_APP_API_ROOT + '/hourly-gender-data', {
                    headers: headers,
                    params: query
                })
                .then(({ data }) => {
                    context.commit('getGenderData', data['body'])
                })
                .catch(error => {
                    console.error(error.response)
                    if(error.response.status == 401){
                        throw new Error("APIの認証に失敗しました。")
                    } else if (error.response.status === 500) {
                        throw new Error("サーバの問題で取得に失敗しました")
                    } else {
                        throw new Error("データの取得に失敗しました")
                    }
                });
        },
        // ストリーム
        async getStreams (context) {
            const headers = {
                "Content-type" : "application/json",
                'Authorization': sessionStorage.getItem('token')
            }
                        
            return await axios
                .get(process.env.VUE_APP_API_ROOT + '/get-streams', { headers: headers })
                .then(({ data }) => {
                    context.commit('getStreams', data['body'])
                })
                .catch(error => {
                    console.error(error.response)
                    if(error.response.status == 401){
                        throw new Error("APIの認証に失敗しました。")
                    } else if (error.response.status === 500) {
                        throw new Error("サーバの問題で取得に失敗しました")
                    } else {
                        throw new Error("データの取得に失敗しました")
                    }
                });
        }
    }
})

export default ReportDataList